'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faQrcode } from '@fortawesome/free-solid-svg-icons'
import {
  Body,
  ButtonLG,
  Container,
  Reveal,
  Section,
  SectionHeader,
  Stagger,
} from 'design-studio'
import { NavigationData } from '@/components/data-links'

export function SectionCta() {
  return (
    <Section id="cta" className="relative scroll-mt-19 py-16 sm:pt-24 sm:pb-32">
      <Container className="relative z-10 max-w-6xl">
        <Stagger>
          <Reveal>
            <SectionHeader
              pretitle="Get started"
              pretitleColor="text-teal-500"
              title="Discover, observe, and reason about your software"
              description={
                <Body size="xl" tone="muted">
                  Use SpecLogician to help developers and LLM coding agents
                  discover the mathematical model implicit in requirements,
                  source code, scenarios, tests, logs, and traces — then use it
                  for reasoning, verification, semantic observability, and test
                  generation.
                </Body>
              }
            />

            <div className="mt-16 flex flex-col items-center gap-5 text-center lg:my-24">
              <Body
                size="xl"
                tone="muted"
                className="max-w-4xl text-balance lg:text-3xl!"
              >
                Sign up for an Imandra Universe account to get your API key and
                start reasoning about your software today.
              </Body>
              <ButtonLG
                href={NavigationData.signup.href}
                variant="none"
                ariaLabel={NavigationData.signup['aria-label']}
                classNames="bg-teal-700 font-bold whitespace-nowrap text-white hover:bg-teal-600"
              >
                <FontAwesomeIcon icon={faQrcode} className="h-4 w-4" />
                Start now{' '}
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="h-4 w-4 -translate-x-1 opacity-0 transition-all duration-200 ease-out group-hover:translate-x-1 group-hover:opacity-100"
                />
              </ButtonLG>
            </div>
          </Reveal>
        </Stagger>
      </Container>
    </Section>
  )
}
